export const LIKE = 'like';
export const DISLIKE = 'dislike';

export const QUERY_NAME = 'recs';

export const MAJOR_APPLIANCE = 'MAJOR_APPLIANCE';
export const LIKE_CLICK = 'instant-recs-like.click';
export const DISLIKE_CLICK = 'instant-recs-dislike.click';

// INSTANT RECS
export const THUMBS_UP_GRAY = 'thumbs-up-gray.svg';
export const THUMBS_UP_ORANGE = 'thumbs-up-orange.svg';
export const THUMBS_DOWN = 'thumbs-down-gray.svg';
export const HOME_DEPOT_DESIGN_CENTER = 'HDDC';

export const POD_IMAGE_SIZE = 300;

// ATC DRAWER RECOMMENDATION
export const RECOMMENDATIONS = {
  TITLE: {
    atc: 'Suggested Items',
    essential_accessories: 'Don\'t Forget This'
  },
  IMPRESSION: {
    ID: {
      atc: '00ATCDEFVALSI00',
      essential_accessories: '00ATCDEFVALEA00',
      cart_instock: '00ATCDEFVALSIMI00',
      pipcollection: '00ATCDEFVALPC00',
      brand_based_collection: '00ATCDEFVALBBR00',
      brand_based_collection_complementary: '00ATCDEFVALBBR00',
      battery_collection: '00ATCDEFVALBC00'
    }
  }
};

export const TIMEOUT = 3000;

/**
 * following constants are used for DiscoveryZoneCarousel
 *
 */
export const newRelicConstants = {
  // ad types
  CAROUSEL_PLA: 'sponsoredDiscoveryZoneCarousel',

  // event types
  LOAD: 'load',
  IMPRESSION: 'impression',
  CLICK: 'click',
  PLA_CAROUSEL_MOUNT: 'pla_carousel_mount',
  PLA_PRODUCT_POD_MOUNT: 'pla_product_pod_mount',
  PLA_CAROUSEL_SLIDE_CHANGE: 'pla_carousel_slide_change',
  PLA_CAROUSEL_NOT_MOUNTED: 'pla_carousel_not_mounted',
  PLA_CAROUSEL_FILTERED_PRODUCTS: 'pla_carousel_filtered_products',

  // click sources
  CLICK_SRC_PRODUCT_SHOP_NOW_BUTTON: 'productShopNowButton',
  CLICK_SRC_PRODUCT_ATC_BUTTON: 'productAtcButton',
  CLICK_SRC_PRODUCT_IMAGE: 'productImage',
  CLICK_SRC_PRODUCT_HEADER: 'productHeader',
  CLICK_SRC_PRODUCT_RATING: 'productRating',
  CLICK_SRC_PRODUCT_POD: 'productPod',
  CLICK_SRC_NEW_TAB: 'clickNewTab',
};

export const AD_INTERACTIONS_KEY = 'sponsoredAdInteractions';
export const INTERACTION_MONITOR_INTERVAL_MS = 10000; // 10s
export const PROCESS_INTERACTIONS_DELAY_MS = 3000; // 3s
